import { FC } from 'react';
import styled from 'styled-components';

const BottomBarElement = styled.div`
  grid-area: bottombar;
  display: flex;
  border-top: 1px solid ${props => props.theme.vars.newColor.lightGS1};
  z-index: 8;
  height: 55px;
`;

export const BottomBar: FC = props => {
  return <BottomBarElement>{props.children}</BottomBarElement>;
};
